"use strict";
// This file will be deprecated with refactor
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouterType = void 0;
var RouterType;
(function (RouterType) {
    RouterType["BrowserRouter"] = "BrowserRouter";
    RouterType["HashRouter"] = "HashRouter";
})(RouterType = exports.RouterType || (exports.RouterType = {}));
//# sourceMappingURL=types.js.map